export default "__VITE_ASSET__FKQFVHqb__"